(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/hooks/use-local-storage.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/hooks/use-local-storage.js');
"use strict";

const {
  useCallback,
  useState
} = React;
const useLocalStorage = function (key) {
  let initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let expirationTimeMS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      const itemValue = item ? JSON.parse(item) : initialValue;
      const now = new Date().getTime();
      const hasExpired = expirationTimeMS && (itemValue === null || itemValue === void 0 ? void 0 : itemValue.exp) && itemValue.exp < now;
      if (hasExpired) {
        return initialValue;
      }
      return itemValue;
    } catch (error) {
      return initialValue;
    }
  });
  const setValue = useCallback(value => {
    setStoredValue(storedValue => {
      try {
        const valueToStore = typeof value === 'function' ? value(storedValue) : value;
        if (expirationTimeMS) {
          valueToStore.exp = new Date().getTime() + expirationTimeMS;
        }
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
        return valueToStore;
      } catch (error) {
        return storedValue;
      }
    });
  }, [key, expirationTimeMS]);
  return [storedValue, setValue];
};
svs.kenoXpress.react.hooks.useLocalStorage = useLocalStorage;

 })(window);